import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Grid,
} from '@crossnokaye/ux-common';

import { IconConfig, IconConfigVariant } from '@repo/sdk/models/components';

import { AnimaticIcon } from '@/features/equipment-browser/animatics/animatic-icon';
import { SubcomponentAttributeConfig } from '@/features/equipment-browser/equipment-details/state/related-devices.state';

import { SubcomponentAttribute } from './subcomponent-attribute';

interface SubcomponentTemplateProps {
  displayName: string;
  icon: IconConfig;
  attributes: SubcomponentAttributeConfig[];
}

export const Subcomponent = ({
  displayName,
  icon,
  attributes,
}: SubcomponentTemplateProps): React.ReactNode => {
  return (
    <Accordion
      key={`accordion-${displayName}`}
      type={'multiple'}
      defaultValue={[`subcomponents-${displayName}`]}
    >
      <AccordionItem value={`subcomponents-${displayName}`} className={'border-0 px-0'}>
        <AccordionTrigger
          icon={
            <AnimaticIcon
              icon={icon?.icon ?? ''}
              variant={icon?.variant ?? IconConfigVariant.Default}
              size={'sm'}
            />
          }
          variant={'small'}
          title={displayName}
          className="bg-[#191919] px-gutter-sm" // TODO: convertify to ux-common color.  this is from the designs but not in ux-common yet.
        />
        <AccordionContent className="pt-thin pb-0">
          <Grid variant="responsive-3" gap="thin">
            {attributes?.map((attribute: SubcomponentAttributeConfig, index: number) => {
              return (
                <SubcomponentAttribute
                  key={`${displayName}--attribute-${index}`.replace(/ /g, '-')}
                  attribute={attribute}
                />
              );
            })}
          </Grid>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
